import Vue from 'vue';

Vue.component('radio-input-black', {
    props: {
        checked: {
            value: String,
        },
    },

    data() {
        return {
            checkedId: '',
        };
    },

    mounted() {
        if (this.checked) {
            this.checkedId = this.checked;
        }
    },

    destroyed() {},

    watch: {},

    methods: {
        changeSelected(id) {
            this.checkedId = id;
        },

        checkIsSelected(id) {
            if (this.checkedId == id) return true;
            return false;
        },

        getGender() {
            return this.checkedId;
        },
    },
});
